module.exports = __webpack_public_path__ + "img/digital2.bbc55b87.svg";